import { render, staticRenderFns } from "./InversionesSecurity.vue?vue&type=template&id=453249b9"
import script from "./InversionesSecurity.vue?vue&type=script&lang=js"
export * from "./InversionesSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports